
import AdvItem from './AdvItem'

export default function AdvList({website}) {
    const deployAdvs = ()=>{
        if(website?.settings?.advertisments?.length === 0 ){
            return <h4>הרשימה ריקה</h4>
        }
        return website?.settings?.advertisments?.map((item, inx)=>{
            return <AdvItem key={`dashbaord_advItem_${inx}`} website={website} item={item}/>
        })
    }
  return (
    <div dir='rtl'>
        <h2>רשימת התמונות שנבחרו</h2>
        <div className='advForm_list'>
            {deployAdvs()}
        </div>
    </div>
  )
}
